import { render, staticRenderFns } from "./RemoveSubmitModal.vue?vue&type=template&id=144ce842&scoped=true&"
import script from "./RemoveSubmitModal.vue?vue&type=script&lang=js&"
export * from "./RemoveSubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveSubmitModal.vue?vue&type=style&index=0&id=144ce842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144ce842",
  null
  
)

export default component.exports